import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import CodeDataPickerCpt from '@/components/data-picker/CodeDataPickerCpt';
import AddrDataPickerCpt from '@/components/data-picker/AddrDataPickerCpt';
import { rqtPostCustomeAddrsInfo } from '@/services/cms/customer';
import { rqtGetPlace } from '@/services/common/place';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    CodeDataPickerCpt,
    AddrDataPickerCpt
  },
  data() {
    return {
      btnLoading: false,
      form: {
        id: undefined,
        addressType: {
          text: undefined,
          value: undefined
        },
        pcc: undefined,
        province: undefined,
        city: undefined,
        country: undefined,
        street: undefined,
        isDefault: undefined
      },
      fItemDataIndex: undefined,
      codeResItems: [{
        title: '地址类型',
        dataIndex: 'addressType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'addressType'
      }],
      detail: undefined
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    this.initResCodeType(this.codeResItems).then(() => {
      this.initDetail();
    });
  },
  unmounted() {
    this.detail = undefined;
  },
  methods: {
    initDetail() {
      let item = this.$route.query && this.$route.query.item;
      if (item) {
        item = JSON.parse(item);
        this.detail = item;
        this.form.id = item.id;
        this.initFitemTextValue('addressType', item.addressType);
        this.form.province = item.province;
        this.form.city = item.city;
        this.form.country = item.country;
        this.initFitemAddr(this.form);
        this.form.street = item.street || '';
        this.form.isDefault = item.isDefault || 'Y';
      }
    },
    initFitemTextValue(fItemIndex, value) {
      let fItem = this.form[fItemIndex];
      fItem.value = value;
      fItem.text = this.formatSelectColumn(this.codeResItems, fItemIndex, {
        [fItemIndex]: value
      });
    },
    async initFitemAddr(addr) {
      if (addr) {
        await Promise.all([rqtGetPlace({
          placeType: '01',
          placeCode: addr.province
        }), rqtGetPlace({
          placeType: '02',
          placeCode: addr.city
        }), rqtGetPlace({
          placeType: '03',
          placeCode: addr.country
        })]).then(([res1, res2, res3]) => {
          const resData1 = res1.data.data;
          const resData2 = res2.data.data;
          const resData3 = res3.data.data;
          addr.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join('/');
        }).catch(() => {});
      }
    },
    onPickerSelectClick(dataIndex, type, tag) {
      this.fItemDataIndex = dataIndex;
      this.$refs['CodeDataPickerCpt'].showView(type || dataIndex);
      if (tag) {
        this.fItemDataIndex = tag;
      }
    },
    onPickerSelected(selectedValues, selectedOptions) {
      const index = /\[(.+?)\]/g.exec(this.fItemDataIndex);
      if (index) {
        let addressType = this.form.addrs[index[1]].addressType;
        addressType.text = selectedOptions[0].codeName;
        addressType.value = selectedValues[0];
      } else {
        let code = this.form[this.fItemDataIndex];
        code.text = selectedOptions[0].codeName;
        code.value = selectedValues[0];
      }
    },
    onPickerAddrDataSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['AddrDataPickerCpt'].showView();
    },
    onPickerAddrDataSelected(val) {
      let addr = this.form;
      addr.pcc = val.map(e => e.placeName).join('/');
      addr.province = val[0] && val[0].placeCode;
      addr.city = val[1] && val[1].placeCode;
      addr.country = val[2] && val[2].placeCode;
    },
    onSubmit() {
      this.btnLoading = true;
      const form = JSON.parse(JSON.stringify(this.form));
      for (const key in form) {
        if (key === 'addrs') {
          form[key].forEach(element => {
            if (this.isTextValueFitem(element, 'addressType')) {
              element.addressType = element.addressType.value;
            } else if (this.hasTextValueFitem(element, 'addressType')) {
              element.addressType = undefined;
            }
          });
        } else {
          if (this.isTextValueFitem(form, key)) {
            form[key] = form[key].value;
          } else if (this.hasTextValueFitem(form, key)) {
            form[key] = undefined;
          }
        }
      }
      form.agentId = this.user.agentId;
      rqtPostCustomeAddrsInfo({
        customerId: this.user.customerId,
        customerAddressList: [form]
      }).then(() => {
        this.btnLoading = false;
        this.$message.success('操作成功');
        this.$router.go(-1);
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    isTextValueFitem(form, key) {
      return form[key] && typeof form[key] === 'object' && form[key].value && 'text' in form[key] && 'value' in form[key];
    },
    hasTextValueFitem(form, key) {
      return form[key] && typeof form[key] === 'object';
    },
    onSaveClick() {
      this.$refs.form.submit();
    }
  }
};